import { combineReducers } from 'redux';
import { METADATA_KEY, metadataReducer } from './metadata';
import { PARAMETERS_KEY, parametersReducer } from './parameters';
import { PENDING_PARAMETERS_KEY, pendingParametersReducer } from './pendingParameters';
import { STATUS_KEY, statusReducer } from './status';
import { FACETS_KEY, facetsReducer } from './facets';
import { SEARCH_ANALYTICS_KEY, searchAnalyticsReducer } from './analytics';

export default combineReducers({
    [FACETS_KEY]: facetsReducer,
    [METADATA_KEY]: metadataReducer,
    [PARAMETERS_KEY]: parametersReducer,
    [PENDING_PARAMETERS_KEY]: pendingParametersReducer,
    [STATUS_KEY]: statusReducer,
    [SEARCH_ANALYTICS_KEY]: searchAnalyticsReducer,
});
